import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-loyalty-request-tile',
  templateUrl: './loyalty-request-tile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoyaltyRequestTileComponent {
  @Input() requested: boolean;

  @Output() requestAccessTriger: EventEmitter<void> = new EventEmitter<void>();

  readonly moreDetails = $localize`:@@loyalty-request-tile.moreDetails:More details`;
  readonly loyaltyRequestTileRequestedButton = $localize`:@@loyalty-request-tile.loyaltyRequestTileRequestedButton:Requested`;
  readonly loyaltyRequestTileRequestButton = $localize`:@@loyalty-request-tile.loyaltyRequestTileRequestButton:Request access`;

  handleRequestAccess() {
    this.requestAccessTriger.emit();
  }
}
